document.addEventListener("turbolinks:load", function() {
    $(document).ready(() => {
        $("#pre_register_datum_id_card").change(function () {
            const file = this.files[0];
            if (file) {
                let reader = new FileReader();
                reader.onload = function (event) {
                    $("#id_card_file_thumb")
                      .attr("src", event.target.result);
                    $("#id_card_file_pop")
                      .attr("src", event.target.result);
                };
                reader.readAsDataURL(file);
            }
        });
    });
});